import { Controller } from "@hotwired/stimulus";
import { shouldActivateClickEvent } from "../../utils/keyboardAccessibility";
import {
  announceTodoModalLoaded,
  announceTodoModalLoadError,
  announceTodoModalLoading,
  turboStreamTodoFormUrl,
} from "../../utils/quiz_results_todo_modal";

const ADD_MANAGE_TODO_MODAL_ID = "quiz-results-add-manage-todo-modal";

// Connects to data-controller="case-experience--todo-button"
export default class extends Controller {
  static values = {
    url: String,
    caseName: String,
    timeOnCase: String,
  };

  async save(event) {
    if (!shouldActivateClickEvent(event)) return;

    event.preventDefault();
    event.stopPropagation();

    const url = turboStreamTodoFormUrl(this.urlValue);
    if (!url) return;

    const caseName = this.caseNameValue;
    const timeOnCase = this.timeOnCaseValue;
    const trigger = event.currentTarget;

    announceTodoModalLoading();

    try {
      const response = await fetch(url);
      if (!response.ok) {
        announceTodoModalLoadError();
        console.log(`Failed to save quiz to do: ${response.status} ${response.statusText}`);
        return;
      }
      const html = await response.text();
      announceTodoModalLoaded();
      if (window.Turbo?.renderStreamMessage) {
        await Turbo.renderStreamMessage(html);
      }
      this.modalController()?.show({
        preventDefault() {},
        currentTarget: trigger,
      });
      if (window.analytics?.track) {
        window.analytics.track("saq_save_to_do", {
          page: window.location.href,
          source: "Case Page",
          case_name: caseName,
          time_on_case: timeOnCase,
        });
      }
    } catch (e) {
      announceTodoModalLoadError();
    }
  }

  modalController() {
    const modalRoot = document.getElementById(ADD_MANAGE_TODO_MODAL_ID);
    if (!modalRoot) return null;

    return this.application.getControllerForElementAndIdentifier(modalRoot, "railsui-modal");
  }
}
